'use strict'

import Vue from 'vue'
import store from '@/store'
import axios from 'axios'
import router from '@/router'
import { Toast } from '@/plugins/toast'

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const config = {
  baseURL: process.env.VUE_APP_API_URL || process.env.apiUrl || '',
  mode: 'no-cors',
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json'
  }
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
}

const _axios = axios.create(config)

_axios.interceptors.request.use(
  function (config) {
    let accessToken = store.getters['root/getAccessToken']
    if (accessToken) {
      config.headers['Authorization'] = 'Bearer ' + accessToken
    }

    return config
  },
  function (error) {
    console.error('there was an error in http request')
    return Promise.reject(error)
  }
)

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response
  },
  function (error) {
    let slug = store.getters['root/getSurveySlug']
    switch (error.response.status) {
      case 401:
        if (/\/api\/surveys\/.*\/login/.test(error.config.url)) {
          return Promise.reject(error)
        }

        if (slug) {
          router.push({ name: 'login', params: { slug } })
          Toast.open({ text: 'Your session expired. Please sign in.' })
        } else {
          const msg = 'Your session expired and we are unable to restore your session. ' +
            'Please contact an administrator.'
          Toast.open({ text: msg })
        }
        break
      case 403:
        // Allow Forbidden responses to pass through for Survey checks.
        // These are handled by the relevant calling components.
        if (/^\/api\/surveys\/.*\/check/.test(error.config.url)) {
          Toast.open({ text: "Sorry, but you're not allowed to access this resource." })
          router.push({ name: 'login', params: { slug } })
        }

        break
      default:
        Toast.open({ text: 'Unhandled error, please contact your administrator.' })
    }

    console.log(error.response)
    return Promise.reject(error)
  }
)

Plugin.install = function (Vue, options) {
  Vue.axios = _axios
  window.axios = _axios
  Object.defineProperties(Vue.prototype, {
    axios: {
      get () {
        return _axios
      }
    },
    $axios: {
      get () {
        return _axios
      }
    }
  })
}

export { _axios as axios }

export default Plugin
